import { type Capability } from "owa-capabilities";
import { type MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export const novaMeControlCapability: Capability = {
    isEnabled: (mailboxInfo?: MailboxInfo) => {
        return mailboxInfo?.type !== "SharedMailbox";
    },
    
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return isGlobalFeatureEnabled("mon-fluent-nova-mecontrol");
    },
};
